
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../UserPermissions.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Permission, Permissions_has } from "../../Shared/Roles.js";
import { Button } from "../../Components/Button.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import { RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty as empty_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ReservationTable } from "../../Widgets/Tables/PlanningTable.js";
import { OnTableRowClick$1 } from "../../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function ReservationsContent(props) {
    let elems_2, elems_1, xs_5;
    const patternInput = useTranslation();
    const permissions = usePermissions();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "pb-2"])], (elems_1 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["grow"]),
    })), delay(() => {
        let elems, Label;
        return Permissions_has(permissions, new Permission(11, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3"])], (elems = [createElement(Button, (Label = patternInput[0]("dialog.reservation.new_title"), {
            ComponentState: "enabled",
            Icon: Calendar_Add(),
            Label: Label,
            OnClick: () => {
                RouterModule_nav(ofArray(["reservations", "new"]), 1, 1);
            },
            TestId: "add-new-reservation-button",
            Variant: "primary",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (xs_5 = [createElement(ReservationTable, {
        Options: {
            Controls: empty_1(),
            DisplayReceiverName: true,
            IsReservationStateVisible: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto) => {
                let matchValue;
                return RouterModule_encodeParts(ofArray(["reservations", (matchValue = dto.GroupId, (matchValue == null) ? dto.Id : matchValue)]), 1);
            }]),
            RowSelection: "disabled",
        },
        Reservations: props.Reservations,
        UserData: props.UserData,
    })], react.createElement(react.Fragment, {}, ...xs_5))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ReservationView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Reservations;
    const matchValue_1 = state_1.CustomerConfiguration;
    let matchResult, customerConfiguration, reservations;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        customerConfiguration = matchValue_1.fields[0];
        reservations = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ReservationsContent, {
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Reservations: reservations,
                UserData: props.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

